/**
 * Screen history helpers for arc BACK navigation.
 *
 * Arcs track which screens have been visited in a mutable
 * `_screenHistory` stack on the arc context. Forward transitions
 * `pushScreen(name)` before targeting the next state; BACK transitions
 * pop the top of the stack and jump to its value.
 *
 * These helpers are shared between identity and intake arcs (and any
 * future arc that needs sibling-BACK support).
 */

import { assign } from "xstate";
import type { KioskMachineContext } from "../types";

// biome-ignore lint/suspicious/noExplicitAny: XState action typing for inline assign in transitions
export const pushScreen = (screen: string): any =>
  assign({
    _screenHistory: ({ context }: { context: KioskMachineContext }) => [
      ...((context._screenHistory as string[]) ?? []),
      screen,
    ],
  });

// biome-ignore lint/suspicious/noExplicitAny: XState action typing for inline assign in transitions
export const popScreen = (): any =>
  assign({
    _screenHistory: ({ context }: { context: KioskMachineContext }) => {
      const history = (context._screenHistory as string[]) ?? [];
      return history.slice(0, -1);
    },
  });

export function peekScreen(context: KioskMachineContext): string | undefined {
  const history = (context._screenHistory as string[]) ?? [];
  return history[history.length - 1];
}
